import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewClasificacionCaravana = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'clasificacion_caravana',
        name: 'Clasificacion Caravana',
        component: ViewClasificacionCaravana,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
